import React from 'react';
import { useApi } from '@bumble/app/hooks/use-api';
import { apiError } from '@bumble/app/utils/api-error';
import { Box, Button, TextField } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

interface AppServiceDescEditProps {
  onSubmit: () => void;
  appServiceId: string;
  appServiceDesc: string;
}
export const AppServiceDescEdit = ({
  onSubmit,
  appServiceId,
  appServiceDesc,
}: AppServiceDescEditProps) => {
  const api = useApi();
  const [desc, setDesc] = React.useState(appServiceDesc || '');

  const epNamePost = useMutation(api.setAppServiceDescriptionApiV1SetAppServiceDescriptionPost, {
    onSuccess() {
      toast.success('Updated Endpoint description successfully.');
      onSubmit();
    },
    onError: apiError,
  });

  const handleSubmit = () => {
    epNamePost.mutate({
      app_service_id: appServiceId,
      description: desc,
    });
  };

  return (
    <Box pt={2}>
      <TextField
        fullWidth
        id="app-service-desc"
        label="App Service Description"
        variant="outlined"
        sx={{ mb: 4 }}
        value={desc}
        onChange={(e) => setDesc(e.target.value)}
        multiline
        minRows={4}
      />

      <Box display="flex" justifyContent="flex-end" sx={{ mt: 5 }}>
        <Button variant="outlined" onClick={handleSubmit}>
          Save Description
        </Button>
      </Box>
    </Box>
  );
};
